import { render, staticRenderFns } from "./NewRuleTab.vue?vue&type=template&id=b2e0619e&scoped=true&"
import script from "./NewRuleTab.vue?vue&type=script&lang=js&"
export * from "./NewRuleTab.vue?vue&type=script&lang=js&"
import style0 from "./NewRuleTab.vue?vue&type=style&index=0&id=b2e0619e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e0619e",
  null
  
)

export default component.exports